// extracted by mini-css-extract-plugin
module.exports = {"root":"IconReviewStar_root__19CM6","filled":"IconReviewStar_filled__2Vkfg"};